import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import get from "lodash/get";
import ReactPhoneInput from "react-phone-input-2";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Button from "@material-ui/core/Button";
import { Helmet } from "react-helmet";
import { instance, instanceMultipart } from "../../../Actions/AxiosInstance";
import { updateAuthentication } from "../../../Actions/AuthenticationAction";
import { updateSubscriptionInfo } from "../../../Actions/SubscriptionInfo";
import {
  ValidateAction,
  ValidateReqField,
  ValidateReqFields,
} from "../../../Utils/Validation";
import loader from "../../../Assets/Gif/loader.gif";
import ProfileImg1 from "../../../Assets/Images/profile_defaultImg.svg";
import { CustomForm } from "../../../Assets/Js/CustomForm";
import createstore from "../../../store";
import { getEJ2CalenderDateFormat } from "../../../Utils";
import { ChangeLanguage } from "../../../Actions/LanguageAction";
import { ReducersTypes } from "../../../Constants";
import "./Profile.css";
import TextField from "../../../Component/Material-ui/TextField";
import { DatePickerComponent } from "../../../Component/Custom";


const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: "hidden",
    position: "relative",
    display: "flex",
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  tabheading: {
    fontSize: 16,
    textTransform: "capitalize",
    padding: 0,
  },
  button: {
    margin: theme.spacing.unit,
  },
});
const thumb = {
  display: "inline-flex",
  borderRadius: 2,
  border: "1px dashed rgb(102, 102, 102)",
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  height: 100,
  padding: 4,
  boxSizing: "border-box",
  borderWidth: 2,
};
class BasicEmpProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      progress: 0,
      candidateid: null,
      // subscriptionid: this.props.match.params.subscriptionid,
      // accountid: this.props.match.params.accountid,
      reqFields: {
        // ProfileImg: "",
        firstname: "",
        // lastname: "",
        dob: "",
        emailid: this.props.SubscriptionInfo.candidateemailid
          ? this.props.SubscriptionInfo.candidateemailid
          : "",
        no: this.props.SubscriptionInfo.candidatemobilenumber
          ? this.props.SubscriptionInfo.candidatemobilenumber
          : "",
        // aboutyourself: ""
        
      },
      fields: {
        ProfileImg: "",
        firstname: "",
        lastname: "",
        dob: "",
        emailid: this.props.SubscriptionInfo.candidateemailid
          ? this.props.SubscriptionInfo.candidateemailid
          : "",
        callingcode: this.props.SubscriptionInfo.callingcode
          ? this.props.SubscriptionInfo.callingcode
          : "",
        no: this.props.SubscriptionInfo.candidatemobilenumber
          ? this.props.SubscriptionInfo.candidatemobilenumber
          : "",
        // aboutyourself: "",
        customfield: null,
      },
      errors: {},
      helperText: {},
      width: 800,
      height: 182,
      ProfileImg: ProfileImg1,
      maxDate: new Date(),
      isadharno: false,
    };
    this.ValidateField = this.ValidateField.bind(this);
    
  }

  componentWillMount() {
    // return;
    if (
      createstore.getState().SubscriptionInfo.SubscriptionData &&
      createstore.getState().SubscriptionInfo.SubscriptionData.companyotp
    ) {
      this.props.ChangeLanguage("basicempprofile");
      const { SubscriptionInfo } = createstore.getState();
      const { accountid } = SubscriptionInfo.SubscriptionData;
      const { subscriptionid } = SubscriptionInfo.SubscriptionData;
      const { countrytimezoneid } = SubscriptionInfo.SubscriptionData;
      const { subscriptionname } = SubscriptionInfo.SubscriptionData;
      this.setState(
        {
          accountid,
          subscriptionid,
          countrytimezoneid,
          subscriptionname,
        },
        this.getSectionCustomField(accountid, subscriptionid),
      );
      const result = {
        data: {
          result: [],
        },
      };
      const employeeid = "";
      const companyotp = "";
      const info = createstore.getState().SubscriptionInfo.SubscriptionData;
      result.data.result[0] = Object.assign(info, { employeeid, companyotp });
      this.props.updateSubscriptionInfo(
        `${ReducersTypes.SUBSCRIPTIONINFO}_FULFILLED`,
        result,
      );
      // CustomForm();
    } else {
      this.props.history.push("./404");
      window.location.reload();
    }
  }

  getSectionCustomField(accountid, subscriptionid) {
    instance
      .get(`employee/sectioncustomfield/1/${subscriptionid}/${accountid}`)
      .then((result) => {
        let { fields } = this.state;
        fields.customfield = result.data.result[0].data
          ? result.data.result[0].data
          : [];
        fields.customfield &&
          fields.customfield.length > 0 &&
          fields.customfield.map((x) => {
            x.fieldvalue = null;
          });
        this.setState({
          sectionFeilds: result.data.result[0].data
            ? result.data.result[0].data
            : [],
          fields: fields,
        });
      });
  }

  SetHelperTextFlag(field, HtField, e) {
    const { helperText } = this.state;
    helperText[field] = true;
    this.setState({ helperText });
  }

  OnFieldChange(field, type, index = null, e) {
    const { fields } = this.state;
    if (index != null && fields.customfield && fields.customfield.length > 0) {
      // fields.customfield[index].fieldvalue = e.target.value
      //   ? e.target.value.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim()
      //   : "";

      fields.customfield[index].fieldvalue = e.target.value
        ? e.target.value
        : "";

      

    } else {
      fields[field] = e.target.value ? e.target.value : "";
    }

    this.setState({ fields });
    if (index == null) {
      ValidateAction(this.state, field, type);
    }
  }

  OnPhoneChange(field, value) {
    this.state.fields.countryname = value.name;
    this.state.fields.callingcode = this.props.SubscriptionInfo.callingcode
      ? this.props.SubscriptionInfo.callingcode
      : value.dialCode;
    this.state.fields.mobilenumber = field;
    field = field.replace(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g, "");
    const no = field.replace(value.dialCode, "");
    this.state.fields.no = no.trim();

    const { fields } = this.state;
    this.setState({ fields });
  }

  ValidateField(reqField, type, e) {
    const { reqFields } = this.state;
    reqFields[reqField] = e.target.value ? e.target.value : "";
    this.setState({ reqFields });
    if (ValidateAction(this.state, reqField, type)) {
      ValidateReqField(this.state, reqField, type);
    }
  }

  ValidateOnNext(reqField, type) {
    const { errors } = this.state;
    if (ValidateAction(this.state, reqField, type)) {
      ValidateReqField(this.state, reqField, type);
    }
    this.setState({ errors });
  }

  convertDate(str) {
    const date = new Date(str);
    const mnth = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  selectDate(args) {
    const dob = this.convertDate(args.value);
    const { fields } = this.state;
    const { reqFields } = this.state;
    fields.dob = dob;
    reqFields.dob = dob;
    this.setState({ fields, reqFields }, () => {
      ValidateReqField(this.state, "dob", "dob");
    });
  }

  ValidateDOB() {
    const { errors } = this.state;
    ValidateReqField(this.state, "dob", "dob");
    this.setState({ errors });
  }

  onCancel(imgname) {
    const { fields } = this.state;
    fields[imgname] = "";
    this.setState({ fields });
  }

  Validate() {
    let formIsValid = true;
    // if (!this.state.file) {
    //   formIsValid = false;
    // }
    if (!ValidateReqFields(this.state)) {
      formIsValid = false;
    }
    return formIsValid;
  }

  
  OnFormSubmit(e) {
    // this.ValidateField.bind(this, "ProfileImg", "name");
    this.forceUpdate();

    if (
      this.state.fields && this.state.fields.customfield && this.state.fields.customfield[0] && this.state.fields.customfield[0].iscompulsory &&
      !this.state.fields.customfield[0].fieldvalue
    ) {
     
      this.setState({ isadharno: true }, () =>
        this.props.enqueueSnackbar(
          "Please enter valid aadhar number",
          {
            variant: "error",
          },
        ),
      );
      return false;
    } else if (this.state.isadharno) {
      this.props.enqueueSnackbar(
        "Please enter valid aadhar number",
        {
          variant: "error",
        },
      );
    } else if (this.state.errors.emailid){
      this.props.enqueueSnackbar("Please enter valid email id", {
        variant: "error",
      });
    } 
    else if (!this.Validate()) {
      this.props.enqueueSnackbar("Please fill all the required fields", {
        variant: "error",
      });
    }   else {
      this.setState({ CommonError: "" });
      const data = {
        ProfileImg: this.state.fields.ProfileImg,
        firstname: this.state.fields.firstname,
        lastname: this.state.fields.lastname,
        dob: this.state.fields.dob,
        emailid: this.props.SubscriptionInfo.candidateemailid
          ? this.props.SubscriptionInfo.candidateemailid
          : this.state.fields.emailid,
        callingcode: this.props.SubscriptionInfo.callingcode
          ? this.props.SubscriptionInfo.callingcode
          : this.state.fields.callingcode,
        primarymobile: this.props.SubscriptionInfo.candidatemobilenumber
          ? this.props.SubscriptionInfo.candidatemobilenumber
          : this.state.fields.no,
        // aboutyourself: this.state.fields.aboutyourself,
        aboutyourself: null,
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        dateformatname: this.props.SubscriptionInfo.dateformatname,
        timezoneid: this.state.countrytimezoneid || 1, // this one set for those fields it gives error of timezone
        candidateid: this.props.SubscriptionInfo.candidateid,
        customfield: this.state.fields.customfield
          ? this.state.fields.customfield
          : null,
      };
      const URL = "employee/insertbasicemployee";
      instance
        .post(URL, data)
        .then((result) => {
          // entrypoint
          const { employeeid } = result.data.result[0];
          const { token } = result.data.result[0];
          let subscriptioninfo =
            createstore.getState().SubscriptionInfo.SubscriptionData;
          subscriptioninfo = { ...subscriptioninfo, employeeid, token };
          this.props.updateSubscriptionInfo(
            `${ReducersTypes.SUBSCRIPTIONINFO}_UPDATED_FOR_EMPLOYEEID`,
            subscriptioninfo,
          );
          this.props.updateAuthentication("LOGIN_UPDATED_WITH_ISFULFILLED", {
            IsFulfilled: false,
            data: null,
          });

          this.profileUpload(employeeid, result);
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  getProfileImg(e) {
    const file = e.target.files[0];
    let extFile;
    if (file) {
      const img = file.name.split(";");
      const imgname = img[0];
      let idxDot;
      idxDot = imgname.lastIndexOf(".") + 1;
      extFile = imgname.substr(idxDot, imgname.length).toLowerCase();
    }
    if (!file) {
    } else if (file.size > 2097152) {
      this.props.enqueueSnackbar(
        "Please Upload Valid Size Image (Maxsize : 2MB)",
        {
          variant: "error",
        },
      );
    } else if (
      !(
        extFile == "png" ||
        extFile == "jpg" ||
        extFile == "jpeg" ||
        extFile == "svg+xml"
      )
    ) {
      this.props.enqueueSnackbar("Please Upload valid image", {
        variant: "error",
      });
    } else {
      const reader = new FileReader();

      reader.onloadend = () => {
        const { reqFields } = this.state;
        reqFields.ProfileImg = file.name;
        this.setState({
          file,
          ProfileImg: reader.result,
          reqFields,
        });
      };
      reader.readAsDataURL(file);

      const { errors } = this.state;
      errors.ProfileImg = false;
      this.setState({ errors });
      // this.ValidateField.bind(this, "ProfileImg", "name")
    }
  }

  profileUpload(employeeid, result) {
    const URL = `/employee/profile/${this.state.accountid}/${this.state.subscriptionid}/${employeeid}/${this.state.countrytimezoneid}`;
    const formData = new FormData();
    if (this.state.file) {
      formData.append("file", this.state.file);
      // formData.append('accountid', this.state.accountid)
      // formData.append('subscriptionid', this.state.subscriptionid)
      // formData.append('employeeid', employeeid)
      // formData.append('timezoneid', this.state.countrytimezoneid)
      this.setState({ ProfileImg: loader });
      instanceMultipart
        .post(URL, formData)
        .then((imgresult) => {
          setTimeout(() => {
            const URL1 = `${window.location.origin}/newemployee/completeprofile`;
            console.log("URL: ", URL1);
            // this.props.history.push("/newemployee/completeprofile");
            window.open(URL1, "_self");
          }, 500);
          // var imgObj = imgresult.data.result[0]["imagesArray"].find(x => x.imagetype == 4);
          // this.setState({ ProfileImg: imgObj.imagepath });
          // let resultApi = result.data.result[0];
          // let info = createstore.getState().SubscriptionInfo.SubscriptionData;
          // result.data.result[0] = Object.assign(resultApi, info, { employeeid });
          // this.props.enqueueSnackbar("Saved successfully", { variant: "success" });
          // this.props.updateAuthentication("LOGIN_UPDATED_WITH_ISFULFILLED", {
          //   IsFulfilled: false,
          //   data: null
          // });
          // this.props.updateSubscriptionInfo(ReducersTypes.SUBSCRIPTIONINFO + "_FULFILLED", result);
          // // this.props.history.push(`/newemployee/completeprofile`);
          // let URL = `${window.location.origin}/newemployee/completeprofile`;
          // window.open(URL, "_self");
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error && error.response
              ? error.response.data.error && error.response.data.error.message
              : error
              ? error.message
              : "Something went wrong",
            { variant: "error" },
          );
          setTimeout(() => {
            const URL1 = `${window.location.origin}/newemployee/completeprofile`;
            console.log("URL: ", URL1);
            // this.props.history.push("/newemployee/completeprofile");
            window.open(URL1, "_self");
          }, 500);
        });
    } else {
      const resultApi = result.data.result[0];
      const info = createstore.getState().SubscriptionInfo.SubscriptionData;
      result.data.result[0] = Object.assign(resultApi, info, { employeeid });
      this.props.enqueueSnackbar("Saved successfully", { variant: "success" });
      this.props.updateSubscriptionInfo(
        `${ReducersTypes.SUBSCRIPTIONINFO}_FULFILLED`,
        result,
      );
      this.props.history.push(`/newemployee/completeprofile`);
    }
  }

  onPicUpload = () => {
    document.getElementById("fileupload").click();
  };

  isValid_Aadhaar_Number(aadhaar_number) {
    // Regex to check valid
    // aadhaar_number
    let regex = new RegExp(/^[2-9]{1}[0-9]{3}\s[0-9]{4}\s[0-9]{4}$/);

    // if aadhaar_number
    // is empty return false
    if (aadhaar_number == null) {
      return "false";
    }

    // Return true if the aadhaar_number
    // matched the ReGex
    if (regex.test(aadhaar_number) == true) {
      this.setState({isadharno:false})
      return "true";
     
    } else {
      this.setState({isadharno:true})
      // this.props.enqueueSnackbar("Aadhar number is invalid", {
      //   variant: "error",
      // });
      //return "false";
    }
  }

  render() {
    const language = this.props.Language.basicempprofile;
    const { sectionFeilds } = this.state;
    return (
      <IntlProvider locale="en" messages={language}>
        <div className="basic-profile-page">
          {/* <div className='basic-profile-box'> */}
          <Helmet>
            <meta charSet="utf-8" />
            <title>Profile Page</title>
          </Helmet>
          <Grid container className="win-height">
            <Grid item xs={12} md={6} sm={3}>
              <div
                style={{
                  marginLeft: "30%",
                  marginTop: "50%",
                  transform: "translateY(-50%)",
                }}
              >
                <h4 className="no-margin greet-text " color="primary">
                  <FormattedMessage
                    id="HelloText"
                    defaultMessage="Lets add your basic details"
                  />
                </h4>
                <div className="welcome-text">
                  <FormattedMessage
                    id="WelcomeText"
                    defaultMessage="Welcome to"
                  />
                  &nbsp;{this.state.subscriptionname}
                </div>
                {/* <div tabindex="0" class="typeform-heading active-color">
                                <div className="inlineClass">
                                    {!this.state["ProfileImg"] ? <div className="circle-number"><FormattedMessage id="Lbnumber1" defaultMessage="1" /></div> : <div className="circle-tick"><FormattedMessage id="tick" defaultMessage="✔" /></div>}
                                </div> &nbsp;
                                    <div className="inlineClass">
                                    <FormattedMessage id="LbProfilePhoto" defaultMessage="Profile Photo" />
                                </div>
                            </div> */}
                <div tabIndex="0" className="typeform-heading">
                  <div className="inlineClass">
                    {!this.state.fields.firstname ? (
                      <div className="circle-number">
                        <FormattedMessage id="Lbnumber1" defaultMessage="1" />
                      </div>
                    ) : (
                      <div className="circle-tick">
                        <FormattedMessage id="tick" defaultMessage="✔" />
                      </div>
                    )}
                  </div>
                  <div
                    className={
                      this.state.fields.firstname
                        ? "inlineClass margin-left-8 active-color"
                        : "inlineClass margin-left-8"
                    }
                  >
                    <FormattedMessage
                      id="LbFirstName"
                      defaultMessage="First Name"
                    />
                  </div>
                </div>
                <div tabIndex="1" className="typeform-heading">
                  <div className="inlineClass">
                    {!this.state.fields.lastname ? (
                      <div className="circle-number">
                        <FormattedMessage id="Lbnumber2" defaultMessage="2" />
                      </div>
                    ) : (
                      <div className="circle-tick">
                        <FormattedMessage id="tick" defaultMessage="✔" />
                      </div>
                    )}
                  </div>

                  <div
                    className={
                      this.state.fields.lastname
                        ? "inlineClass margin-left-8 active-color"
                        : "inlineClass margin-left-8"
                    }
                  >
                    <FormattedMessage
                      id="LbLastName"
                      defaultMessage="Last Name"
                    />
                  </div>
                </div>
                <div tabIndex="2" className="typeform-heading">
                  <div className="inlineClass">
                    {!this.state.fields.dob ? (
                      <div className="circle-number">
                        <FormattedMessage id="Lbnumber3" defaultMessage="3" />
                      </div>
                    ) : (
                      <div className="circle-tick">
                        <FormattedMessage id="tick" defaultMessage="✔" />
                      </div>
                    )}
                  </div>
                  <div
                    className={
                      this.state.fields.dob
                        ? "inlineClass margin-left-8 active-color"
                        : "inlineClass margin-left-8"
                    }
                  >
                    <FormattedMessage
                      id="LbDateOfBirth"
                      defaultMessage="Date Of Birth"
                    />
                  </div>
                </div>
                <div tabIndex="3" className="typeform-heading">
                  <div className="inlineClass">
                    {!this.state.fields.emailid || this.state.errors.emailid ? (
                      <div className="circle-number">
                        <FormattedMessage id="Lbnumber4" defaultMessage="4" />
                      </div>
                    ) : (
                      <div className="circle-tick">
                        <FormattedMessage id="tick" defaultMessage="✔" />
                      </div>
                    )}
                  </div>
                  <div
                    className={
                      this.state.fields.emailid
                        ? "inlineClass margin-left-8 active-color"
                        : "inlineClass margin-left-8"
                    }
                  >
                    <FormattedMessage
                      id="LbEmailId"
                      defaultMessage="Email Id"
                    />
                  </div>
                </div>
                <div tabIndex="4" className="typeform-heading">
                  <div className="inlineClass">
                    {!this.state.fields.no ? (
                      <div className="circle-number">
                        <FormattedMessage id="Lbnumber5" defaultMessage="5" />
                      </div>
                    ) : (
                      <div className="circle-tick">
                        <FormattedMessage id="tick" defaultMessage="✔" />
                      </div>
                    )}
                  </div>
                  <div
                    className={
                      this.state.fields.no
                        ? "inlineClass margin-left-8 active-color"
                        : "inlineClass margin-left-8"
                    }
                  >
                    <FormattedMessage
                      id="Lbmobilenumber"
                      defaultMessage="Phone Number"
                    />
                  </div>
                </div>
                {this.state.fields &&
                  this.state.fields.customfield &&
                  this.state.fields.customfield.length > 0 &&
                  this.state.fields.customfield.map((x) => (
                    <div tabIndex="5" className="typeform-heading">
                      <div className="inlineClass">
                        {!x.fieldvalue ? (
                          <div className="circle-number">
                            <span></span>
                            <FormattedMessage
                              id="Lbnumber6"
                              defaultMessage="6"
                            />
                          </div>
                        ) : (
                          <div className="circle-tick">
                            <FormattedMessage id="tick" defaultMessage="✔" />
                          </div>
                        )}
                      </div>
                      <div
                        className={
                          x.fieldvalue
                            ? "inlineClass margin-left-8 active-color"
                            : "inlineClass margin-left-8"
                        }
                      >
                        <FormattedMessage
                          id="Lbfieldname"
                          defaultMessage={x.fieldname}
                        />
                      </div>
                    </div>
                  ))}
                {/* <div tabindex="5" class="typeform-heading">
                                    <div className="inlineClass">
                                        {!this.state.fields["aboutyourself"] ? <div className="circle-number"><FormattedMessage id="Lbnumber6" defaultMessage="6" /></div> : <div className="circle-tick"><FormattedMessage id="tick" defaultMessage="✔" /></div>}
                                    </div> &nbsp;
                                    <div className="inlineClass">
                                        <FormattedMessage id="LbAboutYourself" defaultMessage="About Yourself" />
                                    </div>
                                </div> */}
              </div>
            </Grid>

            <Grid
              item
              xs={12}
              md={6}
              sm={9}
              className="position-rel"
              style={{ paddingTop: 35 }}
            >
              <div>
                <div className="profile-pic-section">
                  {/* <img src={this.state.fields.ProfileImg} /> */}
                  <div className="profile-pic" onClick={this.onPicUpload}>
                    <div className="add-emp-profile-img" align="center">
                      <img
                        src={this.state.ProfileImg}
                        className="profile-img2"
                      />
                      <span className="onhoverbtn-basicprofile">
                        <input
                          type="file"
                          id="fileupload"
                          onChange={(e) => this.getProfileImg(e)}
                          hidden
                        />
                        <svg
                          viewBox="0 0 24 24"
                          style={{ width: 20, position: "relative", top: 4 }}
                        >
                          <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z" />
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  className="type-form-wrapper basic-profile-container"
                  style={{ overflowY: "auto" }}
                >
                  <div /* id="div" */>
                    <form className="" autoComplete="off">
                      {/* <TextField
                      id="standard-helperText"
                      label={<FormattedMessage id="LbFirstName" defaultMessage="First Name" />}
                      onFocus={this.SetHelperTextFlag.bind(this, "firstname", "HtFirstName")}
                      onChange={this.OnFieldChange.bind(this, "firstname", "name")}
                      margin="normal"
                      // defaultValue="Default Value"
                      // label="first name"
                      //   class="form-control formFirstField width100"
                      // error={this.state.errors["firstname"]}
                      // helperText="Some important text"
                    /> */}

                      <div className="inner-wrapper" tabIndex="0" autoFocus>
                        <div className="margin-bottom-20">
                          <p className="input-form-label">
                            <FormattedMessage
                              id="LbFirstName"
                              defaultMessage="First Name"
                            />
                          </p>
                          {/* <input
                            type="text"
                            className="form-control formFirstField width100"
                            id="firstname"
                            // placeholder="Anika"
                            onFocus={this.SetHelperTextFlag.bind(this, "firstname", "HtFirstName")}
                            onChange={this.OnFieldChange.bind(this, "firstname", "name")}
                            onBlur={this.ValidateField.bind(this, "firstname", "name")}
                            value={this.state.fields.firstname}
                            maxLength="40"
                          /> */}

                          <TextField
                            className="width100"
                            variant="outlined"
                            placeholder="Enter firstname"
                            onFocus={this.SetHelperTextFlag.bind(
                              this,
                              "firstname",
                              "HtFirstName",
                            )}
                            onChange={this.OnFieldChange.bind(
                              this,
                              "firstname",
                              "name",
                              null,
                            )}
                            onBlur={this.ValidateField.bind(
                              this,
                              "firstname",
                              "name",
                            )}
                            value={this.state.fields.firstname}
                            maxLength="40"
                          />

                          <div>
                            {this.state.errors.firstname ? (
                              <span className="caption-error">
                                <FormattedMessage
                                  id="ErFirstName"
                                  defaultMessage="firstname can not be empty"
                                />
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="inner-wrapper" tabIndex="1">
                        <div className="margin-bottom-20">
                          <p className="input-form-label">
                            <FormattedMessage
                              id="LbLastName"
                              defaultMessage="Last Name"
                            />
                            <FormattedMessage
                              id="LbOptional"
                              defaultMessage="(Optional)"
                            />
                          </p>
                          <div>
                            {/* <input
                              type="text"
                              className="form-control width96"
                              id="lastname"
                              style={{ width: "96% !important" }}
                              // placeholder="Mittal"
                              onFocus={this.SetHelperTextFlag.bind(this, "lastname", "HtLastName")}
                              onChange={this.OnFieldChange.bind(this, "lastname", "name")}
                              // onBlur={this.ValidateField.bind(this, "lastname", "name")}
                              value={this.state.fields.lastname}
                              maxLength="100"
                            /> */}
                            <TextField
                              className="width100"
                              variant="outlined"
                              placeholder="Enter lastname"
                              onFocus={this.SetHelperTextFlag.bind(
                                this,
                                "lastname",
                                "HtLastName",
                              )}
                              onChange={this.OnFieldChange.bind(
                                this,
                                "lastname",
                                "name",
                                null,
                              )}
                              value={this.state.fields.lastname}
                              maxLength="100"
                            />
                          </div>
                          <div>
                            {this.state.errors.lastname ? (
                              <span className="caption-error">
                                <FormattedMessage
                                  id="ErLastName"
                                  defaultMessage="recheck last name"
                                />
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="inner-wrapper" tabIndex="2">
                        <div className="margin-bottom-20 ">
                          <p className="input-form-label">
                            <FormattedMessage
                              id="LbDateOfBirth"
                              defaultMessage="Date Of Birth"
                            />
                          </p>
                          <DatePickerComponent
                            className="selectsearch input-area-section width100"
                            // placeholder="Date Of Birth"
                            allowEdit={true}
                            // onClick={() => this.dateObj.show()}
                            // ref={(date)) => (this.dateObj = date)}
                            width={"96%"}
                            start="Decade"
                            format={getEJ2CalenderDateFormat()}
                            id="dob"
                            max={this.state.maxDate}
                            change={this.selectDate.bind(this)}
                            value={get(this.state, "fields.dob", "")}
                          />
                          <div>
                            {this.state.errors.dob ? (
                              <span className="caption-error">
                                {" "}
                                <FormattedMessage
                                  id="ErDateOfBirth"
                                  defaultMessage="Date Of Birth can not be empty"
                                />
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="inner-wrapper" tabIndex="3">
                        <div className="margin-bottom-20">
                          <p className="input-form-label">
                            <FormattedMessage
                              id="LbEmailId"
                              defaultMessage="Email Id"
                            />{" "}
                          </p>
                          {/* <input
                            type="email"
                            className="form-control width96"
                            id="emailid"
                            style={{ width: "96% !important" }}
                            placeholder="abc@lmn.com"
                            onFocus={this.SetHelperTextFlag.bind(this, "emailid")}
                            onChange={this.OnFieldChange.bind(this, "emailid", "email")}
                            onBlur={this.ValidateField.bind(this, "emailid", "email")}
                            value={this.state.fields.email}
                            maxLength="100"
                          /> */}
                          <TextField
                            className="width100"
                            type="email"
                            variant="outlined"
                            placeholder="Enter email"
                            onFocus={this.SetHelperTextFlag.bind(
                              this,
                              "emailid",
                            )}
                            onChange={this.OnFieldChange.bind(
                              this,
                              "emailid",
                              "email",
                              null,
                            )}
                            onBlur={this.ValidateField.bind(
                              this,
                              "emailid",
                              "email",
                            )}
                            value={
                              this.props.SubscriptionInfo.candidateemailid
                                ? this.props.SubscriptionInfo.candidateemailid
                                : this.state.fields.email
                            }
                            disabled={
                              this.props.SubscriptionInfo.candidateemailid
                                ? true
                                : false
                            }
                          />
                          <div>
                            {this.state.errors.emailid ? (
                              <span className="caption-error">
                                <FormattedMessage
                                  id="ErEmailId"
                                  defaultMessage="Are you sure you've entered a correct email? Please re check 🙏"
                                />
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                      <div
                        className="inner-wrapper"
                        tabIndex="4"
                        // style={{ position: "relative", zIndex: 0 }}
                      >
                        <div className="margin-bottom-20">
                          <p className="input-form-label">
                            <FormattedMessage
                              id="Lbmobilenumber"
                              defaultMessage="Phone Number"
                            />
                          </p>

                          <ReactPhoneInput
                            defaultCountry={"in"}
                            country={"in"}
                           
                            countryCodeEditable={false}
                            onFocus={this.SetHelperTextFlag.bind(this, "no")}
                            onChange={this.OnPhoneChange.bind(this)}
                            onBlur={this.ValidateField.bind(
                              this,
                              "no",
                              "mobile",
                            )}
                            value={
                              this.props.SubscriptionInfo.candidatemobilenumber
                                ? this.props.SubscriptionInfo.callingcode +
                                  this.props.SubscriptionInfo
                                    .candidatemobilenumber
                                : this.state.fields.mobilenumber
                            }
                            error={!!this.state.errors.no}
                            InputProps={{ maxLength: 15, minLength: 5 }}
                            className="width100"
                            disabled={
                              this.props.SubscriptionInfo.candidatemobilenumber
                                ? true
                                : false
                            }
                          />
                          <div>
                            {this.state.errors.no ? (
                              <span className="caption-error">
                                <FormattedMessage
                                  id="ErPhoneNumber"
                                  defaultMessage="We won't call you past midnight 😅"
                                />
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>

                      {this.state.fields &&
                        this.state.fields.customfield &&
                        this.state.fields.customfield.length > 0 &&
                        this.state.fields.customfield.map((x, index) => (
                          <div className="inner-wrapper" tabIndex="5" autoFocus>
                            <div className="margin-bottom-20">
                              <p className="input-form-label">
                                <FormattedMessage
                                  id={x.fieldname}
                                  defaultMessage={x.fieldname}
                                />
                              </p>
                              <TextField
                                className="width100"
                                variant="outlined"
                                placeholder={x.fieldname}
                                // onFocus={this.SetHelperTextFlag.bind(
                                //   index,
                                //   x.fieldname,
                                //   "name",
                                // )}
                                onChange={this.OnFieldChange.bind(
                                  this,
                                  "cs_" + x.fieldid,
                                  "name",
                                  index,
                                )}
                                onBlur={this.isValid_Aadhaar_Number.bind(
                                  this,
                                  x.fieldvalue,
                                )}
                                value={x.fieldvalue}
                                inputProps={{ maxLength: 14 }}
                              />

                              

                              <div>
                                {this.state.isadharno ? (
                                  <span className="caption-error">
                                    Aadhar card number is invalid
                                  </span>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      {/* <div class="inner-wrapper opaque" tabindex="5">
                      <div class="form-group">
                        <p class="input-form-label">
                          <FormattedMessage id="LbAboutYourself" defaultMessage="About Yourself" />
                        </p>
                        <div>
                          <input
                            type="text"
                            class="form-control width100"
                            id="aboutyourself"
                            placeholder="About yourself"
                            onFocus={this.SetHelperTextFlag.bind(
                              this,
                              "aboutyourself",
                              "HtAboutYourself"
                            )}
                            onChange={this.OnFieldChange.bind(this, "aboutyourself", "text")}
                            onBlur={this.ValidateField.bind(this, "aboutyourself", "text")}
                            value={this.state.fields.aboutyourself}
                            maxLength="100"
                          />
                        </div>
                        <div>
                          {!!this.state.errors["aboutyourself"] ? (
                            <span className="caption-error">
                              <FormattedMessage
                                id="ErAboutYourself"
                                defaultMessage="can not be empty "
                              />
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div> */}

                      <div className="upform-footer">
                        <Button
                          variant="contained"
                          className="btn btn-primary-md-blue"
                          onClick={this.OnFormSubmit.bind(this)}
                        >
                          <FormattedMessage
                            id="BtSubmit"
                            defaultMessage="Submit"
                          />
                        </Button>
                      </div>
                      <div>
                        {this.state.errors.ProfileImg ? (
                          <span className="caption-error">
                            <FormattedMessage
                              id="ErFavicon"
                              defaultMessage="Say cheese & please add a profile photo 📸"
                            />
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                      <span className="caption-error">
                        {this.state.CommonError}
                      </span>
                    </form>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
          {/* </div> */}
        </div>
      </IntlProvider>
    );
  }
}

BasicEmpProfile.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  SubscriptionInfo: state.SubscriptionInfo.SubscriptionData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateAuthentication,
      ChangeLanguage: (data) => ChangeLanguage(data),
      updateSubscriptionInfo: (type, payload) =>
        updateSubscriptionInfo(type, payload),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(BasicEmpProfile)));
